/**
 * RBAC Context Creation
 * 
 * Separate file for context creation to comply with React Fast Refresh rules
 */

// cspell:ignore IRBAC
import { createContext } from 'react';
import type { RBACContext as IRBACContext } from '../types/rbac';

// Create the RBAC context
export const RBACContext = createContext<IRBACContext | undefined>(undefined);
